import Icon from '../components/Icon.vue'

Icon.register({
  gifts: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M240.6 194.1c-27.8 6.9-48.6 32-48.6 61.9v224c0 11.7 3.4 22.5 8.9 32h-168.9c-17.7 0-32-14.3-32-32v-352c0-17.7 14.3-32 32-32h29.4l-30.7-22c-7.2-5.1-8.8-15.1-3.7-22.3l9.3-13c5.1-7.2 15.1-8.8 22.3-3.7l32.1 22.8-11.5-30.6c-3.2-8.2 1-17.5 9.3-20.6l15-5.6c8.3-3.1 17.5 1.1 20.6 9.4l19.9 53.1 19.9-53c3.1-8.3 12.3-12.5 20.6-9.4l15 5.6c8.3 3.1 12.5 12.3 9.4 20.6l-11.5 30.6 32-22.9c7.2-5.2 17.2-3.5 22.3 3.7l9.3 13c5.2 7.2 3.5 17.2-3.7 22.3l-30.7 22h29.4c12.7 0 23.4 7.5 28.6 18.3-26.7 18.6-42.1 49-44 79.8zM224 480v-96h192v128h-160c-17.7 0-32-14.3-32-32zM448 512v-128h192v96c0 17.7-14.3 32-32 32h-160zM608 224c17.7 0 32 14.3 32 32v96h-192v-128h-15.3l-0.7-0.2-0.7 0.2h-15.3v128h-192v-96c0-17.7 14.3-32 32-32h20.4c-2.7-7.6-4.4-15.5-4.4-23.8 0-35.5 27-72.2 72.1-72.2 48 0 75.8 47.7 87.9 75.3 12-27.6 39.8-75.3 87.9-75.3 45.1 0 72.1 36.7 72.1 72.2 0 8.3-1.8 16.2-4.4 23.8h20.4zM336 224h52.6c-8.9-20.6-25.8-48-44.5-48-17.7 0-24.1 14.5-24.1 24.2 0 5.2 1.5 12.6 8.8 19 2.1 1.8 4.5 3.4 7.2 4.8zM535.2 219.2c7.3-6.4 8.8-13.8 8.8-19 0-9.7-6.4-24.2-24.1-24.2-18.7 0-35.7 27.7-44.5 48h52.6c2.7-1.4 5.1-3 7.2-4.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gifts.js
// module id = 1385
// module chunks = 0